import { useEffect, useState } from "react";
import Lenis from "lenis";

// Simple module-level store so any component can read the current scroll value.
let scrollY = 0;
const listeners = new Set();
let lenisInstance = null;

export function getLenis() {
  return lenisInstance;
}

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 0.9,
      touchMultiplier: 1.4,
    });
    lenisInstance = lenis;
    if (typeof window !== "undefined") window.__lenis = lenis;

    const onScroll = ({ scroll }) => {
      scrollY = scroll;
      listeners.forEach((fn) => fn(scroll));
    };
    lenis.on("scroll", onScroll);

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
}

export function useLenisScroll() {
  const [value, setValue] = useState(scrollY);
  useEffect(() => {
    const fn = (v) => setValue(v);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  return value;
}
